import Flex from 'components/common/Flex';
import Section from 'components/common/Section';
import React, { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import PrimaryInfo from './create-project-component/PrimaryInfo';
import ProjectDocumentation from './create-project-component/ProjectDocumentation';

const CreateProject = () => {
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);

  const handleSubmit = event => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };
  return (
    <Section
      className={'py-0 mx-auto font-sans-serif '}
      style={{ maxWidth: '820px' }}
    >
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <PrimaryInfo />
        <ProjectDocumentation />
        <Card>
          <Card.Body>
            <Flex
              justifyContent={'between'}
              className="flex-column flex-md-row align-items-center"
            >
              <p className="mb-3 mb-md-0 fs-2 fw-medium">Proposed Project</p>
              <Button
                className="w-215px"
                onClick={() => navigate('/project/kanban')}
              >
                Submit
              </Button>
            </Flex>
          </Card.Body>
        </Card>
      </Form>
    </Section>
  );
};

export default CreateProject;
